import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('ai_jwt_token') || '',
    user: localStorage.getItem('ai_user') || ''
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('ai_jwt_token', token)
    },
    SET_USER(state, user) {
      state.user = user
      localStorage.setItem('ai_user', user)
    },
    LOGOUT(state) {
      state.token = ''
      state.user = ''
      localStorage.removeItem('ai_jwt_token')
      localStorage.removeItem('ai_user')
    }
  },
  actions: {
    login({ commit }, { token, username }) {
      commit('SET_TOKEN', token)
      commit('SET_USER', username)
    },
    logout({ commit }) {
      commit('LOGOUT')
    }
  },
  getters: {
    isAuthenticated: state => !!state.token,
    getToken: state => state.token,
    getUser: state => state.user
  }
})
